module.exports = __webpack_public_path__ + "img/_KEV7642.e507ec1f.jpg";